import { HardHat } from "lucide-react";

export default function EmConstrucao() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-700" style={{"flex": "1"}}>
      <div className="flex flex-col items-center gap-4 p-6 rounded-2xl shadow-lg bg-white" style={{"display": "flex", "flexDirection": "column", "alignItems": "center"}}>
        <HardHat className="w-16 h-16 text-yellow-500" style={{"marginTop":"100px", "color": "#1a3d66", "scale":"2"}}/>
        <h2 className="text-2xl font-bold" style={{"color": "#1a3d66"}}>Página em Construção</h2>
        <p className="text-center text-gray-500" style={{"color": "#1a3d66"}}>
          Estamos trabalhando para trazer esta funcionalidade em breve. 🚀
        </p>
      </div>
    </div>
  );
}
